import { isOnPage } from './utils';

/* global Swiper */

if (isOnPage('#promo')) {
  const promoSlider = document.querySelector('#promo');

  const slider = new Swiper(promoSlider.querySelector('.swiper-container'), {
    slidesPerView: 1,
    spaceBetween: 40,
    allowTouchMove: false,
    navigation: {
      prevEl: promoSlider.querySelector('.slider__nav-btn--prev'),
      nextEl: promoSlider.querySelector('.slider__nav-btn--next'),
    },
    speed: 800,
    loop: false,
    breakpoints: {
      992: {
        slidesPerView: 2,
      },
    },
  });
}
